import { BillingPeriodType } from 'api/BillingApi';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { BillingPeriod } from '../types/dates';

export const defaultBillingPeriod = {
  endDatePST: '',
  endDateText: '',
  isFutureDate: false,
  rangeText: '',
  startDatePST: '',
  type: BillingPeriodType.HistoricalCurrentTerm,
};

export type DateContextState = {
  billingCycleStart: string;
  billingCycleEnd: string;
  billingPeriod: BillingPeriod;
  billingPeriods: BillingPeriod[];
  isError: boolean;
  isLoading: boolean;
  setDateRange: (start: string, end: string) => void;
};

const defaultState = {
  billingCycleStart: '',
  billingCycleEnd: '',
  billingPeriod: defaultBillingPeriod,
  billingPeriods: [],
  isError: false,
  isLoading: true,
  setDateRange: noop,
};

export const DateContext = createContext<DateContextState>(defaultState);

export const useDateContext = () => {
  const context = useContext(DateContext);

  if (!context) {
    throw new Error('useDateContext must be used within DateContextProvider');
  }

  return context;
};
